import username from '../../../lib/username'
import isEmpty from 'lodash/isEmpty'
import { DocsType } from '../docs/docsTypes'
import { SyncMap } from 'twilio-sync'
import { State } from '../../reducers/reducerType'
import { SeatingOrderType } from './seatingOrderTypes'
import { debug } from '@bt-react/libs/Logger'
import { SyncMapItem } from 'twilio-sync'

// All users should update the syncSeatingOrder.seatingOrder object when the Map is altered
// - initial state
// - any updates
// - any removals
// - check state after a connection drop of sync

type ConnectionStatus = 'connected' | 'reconnecting' | 'disconnected'

export interface SeatingOrderParticipant {
  dialInStatus: ConnectionStatus
  presenterStatus: ConnectionStatus
  dateUpdated: string | null
}

// Redux Actions

export const setInitialSeatingOrder = (seatingOrderMap: SyncMap) => async (dispatch) => {

  const payload = {}

  try {

    const paginatedResponse = await seatingOrderMap.getItems({ pageSize: 100 })
    for (const { key, data } of paginatedResponse.items) {

      payload[key] = data as SeatingOrderParticipant

    }

  }
  catch (e) {

    debug(e.message)

  }

  return dispatch({ type: SeatingOrderType.SET_SEATING_ORDER_STATE, payload })

}
export const addSeatEntry = ({ item: { key, data } }: { item: SyncMapItem, isLocal: boolean }) => dispatch => dispatch({ type: SeatingOrderType.SEAT_ADDED, payload: { key, data } })
export const updateSeatEntry = ({ item: { key, data } }: { item: SyncMapItem, isLocal: boolean }) => dispatch => dispatch({ type: SeatingOrderType.SEAT_UPDATED, payload: { key, data } })
export const removeSeatEntry = ({ key }) => dispatch => dispatch({ type: SeatingOrderType.SEAT_REMOVED, payload: key })
export const setSeatingOrderMap = (seatingOrderMap: SyncMap) => async (dispatch) => {

  // set the seating order
  await dispatch(setInitialSeatingOrder(seatingOrderMap))

  // dispatch the seatingOrderMap
  return dispatch({ type: DocsType.SET_SEATING_ORDER_MAP, payload: seatingOrderMap })

}
export const seatingOrderSyncListenersAdded = () => ({ type: SeatingOrderType.SEATING_ORDER_SYNC_LISTENERS_ADDED })

export default {
  setSeatingOrderMap,
  seatingOrderSyncListenersAdded,
  setInitialSeatingOrder
}
